module.exports = __webpack_public_path__ + "static/AppStoreQRCode-c9429799096d62e79571ae11f1a67203.jpg";